import { render } from "./iron_ifc_view.vue?vue&type=template&id=bf997ad4&scoped=true"
const script = {}

import "./iron_ifc_view.vue?vue&type=style&index=0&id=bf997ad4&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf997ad4"]])

export default __exports__